export default __webpack_public_path__ + "static/media/left-arrow.72c47e34.svg";